import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
      {/* Halo violet en haut à gauche */}
      <div 
        className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full opacity-30"
        style={{
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, transparent 70%)',
          filter: 'blur(60px)'
        }}
      ></div>
      
      {/* Halo bleu/cyan en bas à droite */}
      <div aria-hidden="true"
        className="absolute inset-0 before:absolute before:-bottom-40 before:-right-40 before:w-[600px] before:h-[600px] before:rounded-full before:opacity-25 before:blur-[80px] before:content-[''] before:bg-[radial-gradient(circle,rgba(6,182,212,0.35)_0%,transparent_70%)]"
      />
      
      {/* Petit halo violet au centre-droit */}
      <div 
        className="absolute top-1/3 right-1/4 w-[300px] h-[300px] rounded-full opacity-20"
        style={{
          background: 'radial-gradient(circle, rgba(168, 85, 247, 0.3) 0%, transparent 70%)',
          filter: 'blur(50px)'
        }}
      ></div>
    </div>
  );
};

export default AnimatedBackground;
